module.exports = __webpack_public_path__ + "images/c46f296b931101b3505847572f996ab4.png";